const populateData = ({ commit, rootState }, tourData) => {
  const imgs = tourData.section_images.sort((a, b) => {
    if (a.filter_id === b.filter_id) {
      return parseInt(parseInt(a.imageset_id, 10) - parseInt(b.imageset_id, 10));
    }
    return parseInt(parseInt(a.filter_id, 10) - parseInt(b.filter_id, 10));
  });

  const slides = imgs.filter(img => img.type === 'gallery').map(image => ({
    id: parseInt(image.imageset_id, 10),
    src: rootState.project.assetsUrl + image.url,
    caption: image.caption,
    isPano: image.type === 'pano'
  }));

  const archSlides = imgs.filter(img => img.type === 'architecture');

  const featSlides = imgs.filter(img => img.type === 'feature');

  const citySlides = imgs.filter(img => img.type === 'cityscape');
  const sealogeSlides = imgs.filter(img => img.type === 'sealoge');
  const skyeSlides = imgs.filter(img => img.type === 'skye');
  const summerSlides = imgs.filter(img => img.type === 'summer');

  console.log(citySlides, sealogeSlides, skyeSlides, summerSlides);
  commit('setSlides', slides);
  commit('setArchSlides', archSlides);
  commit('setFeatSlides', featSlides);
  commit('setSuiteDetails', {
    cityscape: citySlides,
    sealoge: sealogeSlides,
    skye: skyeSlides,
    summer: summerSlides
  });

};

export default {
  populateData,
};



// WEBPACK FOOTER //
// ./src/store/modules/amenities/actions.js